<template>
	<div class="basic-container popup">
		<div class="popup-visit-company-area">
			<section>
				<div class="block">
					<label>사업명</label>
					<input type="text" :value="businessName" :disabled="isReadOnly" />
				</div>
				<div class="block">
					<label>회사명</label>
					<input type="text" :value="companyNmKor" :disabled="isReadOnly" />
				</div>
				<div class="block">
					<label>새싹기업명</label>
					<input type="text" :value="userNmKor" :disabled="isReadOnly" />
				</div>
				<p>
					본 회원은 ｢{{ businessYear }}년 {{ businessTpNm }}지역 특화산업 수출새싹기업 지원사업｣수행에 대해 협약서를 기반으로 지원과제를 성실히 관리할
					것이며, 아래 사항에 대하여 {{ businessTpNm }} 테크노파크 및 새싹기업의 동의 하에 지급된 예산에 대한 환수 및 지급할 예산에 대한 집행을
					보류하여도 이의가 없음에 동의합니다.<br /><br />

					1. 회원의 과오로 인한 사업 진행 간 문제 발생<br />
					<span class="mobile-hide">2. 수출새싹기업지원사업 실행 및 워크숍 진행 간 중복정산*<br /><br /></span>
					<span class="web-hide">2. 수출새싹기업지원사업 실행 및<br />&emsp;&emsp;&emsp;워크숍 진행 간 중복정산*<br /><br /></span>

					<span class="mobile-hide">*중복정산 : 타 지원사업, 타 부처 사업에 대한 정산 서류 중복 제출로 인한 사업비 중복 수령</span>
					<span class="web-hide"
						>*중복정산 : 타 지원사업, 타 부처 사업에 대한<br />
						&ensp;&ensp;&ensp;정산 서류 중복 제출로 인한 사업비 중복 수령</span
					><br /><br />
				</p>
			</section>
		</div>
	</div>
</template>

<script>
import CONST from '@/constants';
import eventBus from '@/plugins/event-bus';

export default {
	title: '사업비관리 동의서',
	name: 'PopupAgreement',
	props: ['modalParam'],
	data: function() {
		return {
			CONST,
			loginMember: null,
			matchData: null,
			select: 1,
			userSubmitState: 'NONE',
			companySubmitState: 'NONE',
			nonAgreeReason: '',
			isShow: true,

			businessName: '사업명',
			companyNmKor: '새싹기업명',
			userNmKor: 'OKTA회원명',
			businessYear: '연도',
			businessTpNm: 'TP지역명',
		};
	},
	created() {
		let matchData = this.$device.loadLocalData('MATCH_DATA');
		if (matchData) this.matchData = JSON.parse(matchData);
		let dt = this.$device.loadLocalData('LOGIN_USER');
		if (dt) this.loginMember = JSON.parse(dt);
	},
	mounted() {
		this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, 'BIZ');
		this.businessName = this.modalParam.businessYear + '년 ' + this.modalParam.businessTpNm + ' 테크노파크';
		this.companyNmKor = this.modalParam.companyNmKor;
		this.userNmKor = this.modalParam.oktaUserNmKor;
		this.businessYear = this.modalParam.businessYear;
		this.businessTpNm = this.modalParam.businessTpNm;
		// this.stateCd = this.matchData.stateCd;
		// this.mtSubmitState = this.matchData.mtSubmitState;
		// this.companySubmitState = this.matchData.companySubmitState;
		// this.startDate = this.$moment(this.matchData.startDate).format('YYYY-MM-DD');
		// this.endDate = this.$moment(this.matchData.endDate).format('YYYY-MM-DD');
		// this.specialContract = this.matchData.specialContract;
		// this.getStateCdList();
		// this.getAgreement();
		eventBus.$on(
			CONST.EVENTS.SAVE_MODAL,
			function(v, t) {
				if (v === 'modalAgree') {
					if (t !== 'CONFIRM') {
						this.doSubmit(t);
						return false;
					} else {
						this.doAgree();
						return false;
					}
				}
			}.bind(this),
		);
		// eventBus.$on(CONST.EVENTS.CONTRACT_UNACCEPT, () => {
		// 	this.getAgreement();
		// });
	},
	beforeDestroy() {
		eventBus.$off(CONST.EVENTS.SAVE_MODAL);
	},
	watch: {},
	computed: {
		isCompany: function() {
			return this.loginMember && this.loginMember.budsUserType === CONST.USER_TYPE.COMPANY;
		},
		isReadOnly: function() {
			return true;
		},
	},
	methods: {
		// getProgressChartListPlaceHolder: function(t, i) {
		// 	if (i < this.progressChartListPlaceHolder.length) {
		// 		if (t === 'PROGRESS_DATE') return this.progressChartListPlaceHolder[i].PROGRESS_DATE;
		// 		else if (t === 'ACTIVITY_FEE') return this.progressChartListPlaceHolder[i].ACTIVITY_FEE;
		// 		else if (t === 'GUBUN') return this.progressChartListPlaceHolder[i].GUBUN;
		// 		else if (t === 'RESULT') return this.progressChartListPlaceHolder[i].RESULT;
		// 		else return '';
		// 	}
		// 	return '';
		// },
		// changeStartDate: function() {
		// 	// var start_date = new Date(sDate[0], sDate[1], sDate[2]);
		// 	// var end_date = new Date(eDate[0], eDate[1], eDate[2]);
		// 	// var step_start_date = new Date(stepStDate[0], stepStDate[1], stepStDate[2]);
		//
		// 	let dt = new Date(this.contractDateStart);
		// 	let dt6 = this.$moment(dt)
		// 		.add(6, 'months')
		// 		.add(-1, 'days');
		// 	let dt12 = this.$moment(dt)
		// 		.add(12, 'months')
		// 		.add(-1, 'days');
		// 	//let dt6 = dt.setFullYear(dt.getFullYear(), dt.getMonth() + 6, dt.getDate() - 1);
		// 	//let dt12 = dt.setFullYear(dt.getFullYear() + 0, dt.getMonth() + 6, dt.getDate() - 1);
		//
		// 	let numStepStartDate = this.startDate.replaceAll('-', '');
		// 	let numContractDateStart = this.contractDateStart.replaceAll('-', '');
		//
		// 	if (numStepStartDate > numContractDateStart) {
		// 		alert('협약기간이 사업시작일보다 이 전 일수는 없습니다. \n날짜를 확인해 주세요');
		// 		this.contractDateStart = '';
		// 		this.contractDateEnd = '';
		// 		return false;
		// 	}
		//
		// 	let endDt = '';
		// 	if (this.stateCd == 'ENTRY') {
		// 		alert('진입단계는 사업개시일 +6개월 입니다.');
		// 		endDt = this.$moment(dt6).format('YYYY-MM-DD');
		// 	} else {
		// 		alert('발전, 확장단계는 사업개시일 +12개월 입니다.');
		// 		endDt = this.$moment(dt12).format('YYYY-MM-DD');
		// 	}
		//
		// 	this.contractDateEnd = endDt;
		// },
		// doSubmit: function(saveType) {
		// 	this.entryFee = this.entryFee.replaceAll(',', '');
		// 	if (this.contractDateStart === '') {
		// 		alert('협약시작일을 선택해 주세요');
		// 		return false;
		// 	}
		// 	if (this.stateCd === '') {
		// 		alert('단계를 선택해 주세요');
		// 		return false;
		// 	}
		// 	if (this.serviceCd1 === '') {
		// 		alert('지원서비스를 선택해 주세요');
		// 		return false;
		// 	}
		// 	if (this.serviceCd1 === this.serviceCd2 || this.serviceCd1 === this.serviceCd3) {
		// 		alert('지원서비스는 중복될 수 없습니다');
		// 		return false;
		// 	}
		// 	if (this.serviceCd2 !== '' || this.serviceCd3 !== '') {
		// 		if (this.serviceCd2 !== 'NONE' || this.serviceCd3 !== 'NONE') {
		// 			if (this.serviceCd2 === this.serviceCd3) {
		// 				alert('지원서비스는 중복될 수 없습니다');
		// 				return false;
		// 			}
		// 		}
		// 	}
		//
		// 	if (!this.isCompany) {
		// 		if (this.entryFee === '') {
		// 			alert('참가비를 입력하세요');
		// 			return false;
		// 		}
		// 		let isProgressFilled = false;
		// 		if (this.stateCd !== 'ENTRY' && this.stateCd !== 'GROW') {
		// 			for (let i = 0; i < this.progressChartList.length; i++) {
		// 				if (
		// 					this.progressChartList[i].PROGRESS_DATE &&
		// 					this.progressChartList[i].ACTIVITY_FEE &&
		// 					this.progressChartList[i].GUBUN &&
		// 					this.progressChartList[i].RESULT
		// 				) {
		// 					isProgressFilled = true;
		// 				}
		// 			}
		// 			if (!isProgressFilled) {
		// 				window.alert('해외지사화사업 확장단계 추진진도표를 입력하세요');
		// 				return false;
		// 			}
		// 		}
		// 	}
		//
		// 	if (saveType === 'DONE') {
		// 		// if (this.itemNm === '') {
		// 		// 	alert('품목을 입력하세요');
		// 		// 	return false;
		// 		// }
		// 		// if (this.hsCode === '') {
		// 		// 	alert('HS CODE를 입력하세요');
		// 		// 	return false;
		// 		// }
		// 		// if (this.offerYn === '') {
		// 		// 	alert('목적외 이용 및 제3자 제공 동의 여부를 선택하세요');
		// 		// 	return false;
		// 		// }
		// 	}
		//
		// 	let stateCd = this.stateCd;
		// 	let serviceCd = this.serviceCd1;
		// 	if (this.serviceCd2) serviceCd += '|' + this.serviceCd2;
		// 	if (this.serviceCd3) serviceCd += '|' + this.serviceCd3;
		//
		// 	let progressChart = stateCd !== 'ENTRY' && stateCd !== 'GROW' ? JSON.stringify(this.progressChartList) : '';
		// 	let etcService = stateCd !== 'ENTRY' && stateCd !== 'GROW' ? this.etcService : '';
		//
		// 	let formData = new FormData();
		// 	formData.append('saveType', saveType);
		// 	formData.append('agreeSeqNo', this.agreeSeqNo);
		// 	formData.append('matchSeqNo', this.matchData.seqNo);
		// 	formData.append('serviceCd', serviceCd);
		// 	formData.append('stateCd', stateCd);
		// 	formData.append('etcService', etcService);
		// 	formData.append('contractDateStart', this.contractDateStart);
		// 	formData.append('contractDateEnd', this.contractDateEnd);
		// 	if (this.itemNm !== 'null' && this.itemNm !== null) formData.append('itemNm', this.itemNm);
		// 	formData.append('hsCode', this.hsCode);
		// 	formData.append('offerYn', this.offerYn);
		// 	formData.append('entryFee', this.entryFee || 0);
		// 	formData.append('progressChart', progressChart);
		// 	formData.append('specialContract', this.specialContract || '');
		// 	this.$apiClient
		// 		.getInstance()
		// 		.post(this.$apiClient.getApiServer() + '/api/business/updateAgreement.do', formData)
		// 		.then(res => {
		// 			if (res.data.resultCode === 0) {
		// 				alert('저장되었습니다.');
		// 				this.getAgreement();
		// 				eventBus.$emit('LOAD_POPUP_AGREEMENT_DATA');
		// 				//window.location.reload();
		// 			} else {
		// 				window.alert(res.data.resultMsg);
		// 			}
		// 		})
		// 		.catch(e => console.error(e));
		// },
		// doCompanyNonReason: function() {
		// 	let param = {
		// 		matchSeqNo: this.matchData.seqNo,
		// 		mtSeqNo: this.matchData.mtSeqNo,
		// 		companySeqNo: this.matchData.companySeqNo,
		// 		nonAgreeReason: this.nonAgreeReason,
		// 		reportType: CONST.REPORT_TYPE.AGREE_REPORT,
		// 	};
		// 	eventBus.$emit(CONST.EVENTS.OPEN_MODAL, 'unacceptModal', '기업현장관리', param);
		// },
		doAgree: function() {
			let formData = new FormData();
			formData.append('matchSeqNo', this.matchData.matchSeqNo);

			// this.$apiClient
			// 	.getInstance()
			// 	.post(this.$apiClient.getApiServer() + '/api/business/updateAgreement/Agree.do', formData)
			// 	.then(res => {
			// 		if (res.data.resultCode === 0) {
			// 			alert('저장되었습니다.');
			// 			eventBus.$emit('LOAD_POPUP_AGREEMENT_DATA');
			// 			window.location.reload();
			// 		} else {
			// 			window.alert(res.data.resultMsg);
			// 		}
			// 	})
			// 	.catch(e => console.error(e));
		},
		// getAgreement: function() {
		// 	let formData = new FormData();
		// 	formData.append('matchSeqNo', this.matchData.seqNo);
		// 	this.$apiClient
		// 		.getInstance()
		// 		.post(this.$apiClient.getApiServer() + '/api/business/getAgreement.do', formData)
		// 		.then(res => {
		// 			if (res.data.resultCode === 0) {
		// 				if (res.data.data !== null) {
		// 					this.apiData = res.data.data;
		// 					this.agreeSeqNo = this.apiData.agreeSeqNo;
		// 					this.nonAgreeReason = this.apiData.nonAgreeReason;
		// 					this.hsCode = this.apiData.hsCode;
		// 					this.itemNm = this.apiData.itemNm;
		// 					this.specialContract = this.apiData.specialContract;
		// 					if (this.apiData.offerYn) this.offerYn = this.apiData.offerYn;
		// 					if (this.apiData.etcService) this.etcService = this.apiData.etcService;
		// 					if (this.apiData.progressChart) {
		// 						this.progressChartList = JSON.parse(this.apiData.progressChart);
		// 						if (this.progressChartList.length < 8) {
		// 							for (let i = 8 - this.progressChartList.length; i > 0; i--) {
		// 								this.progressChartList.push({
		// 									PROGRESS_DATE: '',
		// 									ACTIVITY_FEE: '',
		// 									GUBUN: '',
		// 									RESULT: '',
		// 								});
		// 							}
		// 						}
		// 					}
		// 					this.entryFee = this.apiData.entryFee.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
		// 					if (this.apiData.contractDateStart) this.contractDateStart = this.$moment(this.apiData.contractDateStart).format('YYYY-MM-DD');
		// 					if (this.apiData.contractDateEnd) this.contractDateEnd = this.$moment(this.apiData.contractDateEnd).format('YYYY-MM-DD');
		// 					this.mtSubmitState = this.apiData.mtSubmitState;
		// 					this.companySubmitState = this.apiData.companySubmitState;
		// 					let serviceCd = this.apiData.serviceCd ? this.apiData.serviceCd.split('|') : [];
		// 					if (serviceCd[0]) this.serviceCd1 = serviceCd[0];
		// 					if (serviceCd[1]) this.serviceCd2 = serviceCd[1];
		// 					if (serviceCd[2]) this.serviceCd3 = serviceCd[2];
		//
		// 					this.getEntryFeeList();
		// 				}
		// 				this.getServiceCodeList();
		// 			} else {
		// 				window.alert(res.data.resultMsg);
		// 			}
		// 		})
		// 		.catch(e => console.error(e));
		// },
		// changeService: function(targetEl) {
		// 	if (targetEl === 'stateCd') {
		// 		this.getServiceCodeList();
		// 	} else {
		// 		this.getEtcServiceCodeList();
		// 	}
		// },
		// getStateCdList: function() {
		// 	this.stateCdList = [];
		// 	let formData = new FormData();
		// 	formData.append('parentCodeCd', 'LOCAL_COMPANY_STATE');
		// 	this.$apiClient
		// 		.getInstance()
		// 		.post(this.$apiClient.getApiServer() + '/api/common/getMngCodeList.do', formData)
		// 		.then(res => {
		// 			if (res.data.resultCode === 0) {
		// 				this.stateCdList = res.data.data;
		// 			} else {
		// 				window.alert(res.data.resultMsg);
		// 			}
		// 		})
		// 		.catch(e => console.error(e));
		// },
		// getServiceCodeList: function() {
		// 	this.serviceCodeList = [];
		// 	if (this.stateCd === '') {
		// 		return false;
		// 	}
		// 	let formData = new FormData();
		// 	formData.append('stateCd', this.stateCd);
		// 	this.$apiClient
		// 		.getInstance()
		// 		.post(this.$apiClient.getApiServer() + '/api/common/getServiceCodeList.do', formData)
		// 		.then(res => {
		// 			if (res.data.resultCode === 0) {
		// 				this.serviceCodeList = res.data.data;
		// 				//this.$set(this.serviceCdRowData, idx, nInfo);
		// 			} else {
		// 				window.alert(res.data.resultMsg);
		// 			}
		// 		})
		// 		.catch(e => console.error(e));
		// },
		// addRow: function() {
		// 	this.progressChartList.push({
		// 		PROGRESS_DATE: '',
		// 		ACTIVITY_FEE: '',
		// 		GUBUN: '',
		// 		RESULT: '',
		// 	});
		// },
		// delRow: function() {
		// 	//this.progressChartList.splice(idx, 1);
		// 	if (this.progressChartList.length < 2) window.alert('최소 한행은 있어야 합니다.');
		// 	else this.progressChartList.pop();
		// },
		//TODO 임시 잠금 : 유지보수 1순위
		// getEntryFeeList: function() {
		// 	let formData = new FormData();
		// 	formData.append('parentCodeCd', 'LOCAL_COMPANY_FEE');
		// 	this.$apiClient
		// 		.getInstance()
		// 		.post(this.$apiClient.getApiServer() + '/api/common/getMngCodeList.do', formData)
		// 		.then(res => {
		// 			if (res.data.resultCode === 0) {
		// 				if (res.data.data) {
		// 					for (let i = 0; i < res.data.data.length; i++) {
		// 						if (this.matchData.stateCd === 'GROW') {
		// 							if (res.data.data[i].codeCd === this.matchData.region) {
		// 								this.entryFee = res.data.data[i].codeNm;
		// 							}
		// 						} else {
		// 							if (res.data.data[i].codeCd === this.matchData.stateCd) {
		// 								this.entryFee = res.data.data[i].codeNm;
		// 							}
		// 						}
		// 					}
		// 				}
		// 			} else {
		// 				window.alert(res.data.resultMsg);
		// 			}
		// 		})
		// 		.catch(e => console.error(e));
		// },
	},
};
</script>

<style scoped></style>
